export default {
  setAccountId: (state, accountId) => {
    state.accountId = accountId;
  },
};
